<!--
  - Copyright (c) 2024. Haodong JU
  -->

<template>
  <div>
    <v-card
      :class="isActive?'font-weight-black':''"
      :color="isActive?'grey lighten-4':''"
      elevation="0"
      class="d-flex align-center pa-2"
      @click="$emit('selected',treeNode.name)"
    >
      <div
        style="width: 18px"
        v-if="!isRoot"
      >
        <v-btn
          @click.stop="expand=!expand"
          v-if="!isRoot&&haveChildren"
          x-small
          icon
        >
          <v-icon>
            <template v-if="expand">
              mdi-menu-down
            </template>
            <template v-else>
              mdi-menu-right
            </template>
          </v-icon>
        </v-btn>
      </div>
      <v-icon
        small
        class="mr-2"
      >
        {{ isRoot ? 'mdi-home-variant' : 'mdi-file-tree-outline' }}
      </v-icon>
      <div class="text-body-1">
        {{ treeNode.name }}
      </div>
      <v-spacer />
      <v-btn
        icon
        small
      >
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </v-card>
    <div
      class="pl-4"
      v-if="haveChildren&&(expand||isRoot)"
    >
      <tree-node
        @selected="e=>$emit('selected',e)"
        :current-level="currentLevel+1"
        v-for="c in treeNode.children"
        :tree-node="c"
        :active-name="activeName"
        :key="c.name"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TreeNode',
  props: {
    treeNode: {
      type: Object,
      required: true
    },
    currentLevel: {
      type: Number,
      default: 0
    },
    activeName: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return { expand: false }
  },
  computed: {
    isActive () {
      console.log(this.treeNode.name === this.activeName)
      return this.treeNode.name === this.activeName
    },
    isRoot () {
      return this.currentLevel === 0
    },
    haveChildren () {
      return this.treeNode?.children?.length > 0
    }
  }
}
</script>

<style scoped>

</style>
